var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-full-calendar"},[_c('t-calendar-header',{attrs:{"date":_vm.localeDate},on:{"change-month":_vm.$_changeMonth,"change-year":_vm.$_changeYear}}),_vm._ssrNode(" "),_c('t-calendar-body',{attrs:{"date":_vm.localeDate,"this-date":_vm.thisDate,"week-days":_vm.weekDays}})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fda0a2aa","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/calendar/calendar.vue
// module id = 849
// module chunks = 0 1